"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteIcon = exports.FileName = exports.FileDisplayIcon = exports.FileDisplayImage = exports.FileDiv = exports.FileSizeTypography = exports.ErrorTypography = exports.StyledLinearProgress = exports.StyledFormControl = exports.classes = void 0;
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const styles_1 = require("@mui/material/styles");
const icon_button_1 = __importDefault(require("../icon-button"));
const Icon_1 = __importDefault(require("../icon/Icon"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "Upload";
exports.classes = {
    icon: `${PREFIX}-icon`,
    wrapper: `${PREFIX}-wrapper`,
    accordion: `${PREFIX}-accordion`,
    accordionSummary: `${PREFIX}-accordionSummary`,
    dropZone: `${PREFIX}-dropZone`,
    drag: `${PREFIX}-drag`,
    typography: `${PREFIX}-typography`,
    label: `${PREFIX}-label`,
    instructions: `${PREFIX}-instructions`,
    mobileInstructions: `${PREFIX}-mobileInstructions`,
    input: `${PREFIX}-input`,
    fileInfoWrapper: `${PREFIX}-fileInfoWrapper`
};
exports.StyledFormControl = (0, styles_1.styled)(FormControl_1.default)(({ theme }) => ({
    [`.${exports.classes.icon}`]: {
        color: theme.colours.storm,
        height: "40px",
        width: "40px",
        marginTop: "50px"
    },
    [`.${exports.classes.wrapper}`]: {
        width: "100%"
    },
    [`.${exports.classes.accordion}`]: {
        backgroundColor: theme.colours.white,
        boxShadow: "none",
        border: `1px solid ${theme.colours.storm}`
    },
    [`.${exports.classes.accordionSummary}`]: {
        color: theme.colours.slate,
        fontSize: "18px"
    },
    [`.${exports.classes.dropZone}`]: {
        minHeight: "200px",
        width: "100%",
        border: `1px dashed ${theme.colours.storm}`,
        borderRadius: "3px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: -1,
        transition: "0.5s ease all"
    },
    [`.${exports.classes.drag}`]: {
        borderColor: theme.colours.accent,
        backgroundColor: `${theme.colours.blue100}66`,
        transition: "0.5s ease all"
    },
    [`.${exports.classes.typography}`]: {
        fontSize: "18px",
        padding: "5px",
        color: theme.colours.slate
    },
    [`.${exports.classes.label}`]: {
        fontSize: "18px",
        color: theme.colours.inter,
        textDecoration: "underline",
        cursor: "pointer",
        padding: "5px"
    },
    [`.${exports.classes.instructions}`]: {
        flex: 0,
        marginTop: "40px",
        marginBottom: "10px",
        fontSize: "14px",
        opacity: 0.4
    },
    [`.${exports.classes.mobileInstructions}`]: {
        margin: "10px 5px",
        fontSize: "14px",
        opacity: 0.4
    },
    [`.${exports.classes.input}`]: {
        display: "none"
    },
    [`.${exports.classes.fileInfoWrapper}`]: {
        flex: 1,
        display: "flex",
        flexDirection: "column"
    }
}));
exports.StyledLinearProgress = (0, styles_1.styled)("div")({
    marginTop: "10px",
    marginRight: "5px"
});
exports.ErrorTypography = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    color: theme.colours.error400,
    fontSize: "14px"
}));
exports.FileSizeTypography = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    fontSize: "14px",
    color: theme.colours.storm
}));
exports.FileDiv = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "100%",
    border: `1px solid ${theme.colours.alabaster}`,
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    margin: "10px 0",
    minHeight: "60px",
    padding: "5px"
}));
exports.FileDisplayImage = (0, styles_1.styled)("img")({
    height: "40px",
    width: "40px",
    margin: "10px",
    objectFit: "cover"
});
exports.FileDisplayIcon = (0, styles_1.styled)(Icon_1.default)({
    height: "40px",
    width: "40px",
    margin: "10px",
    objectFit: "cover"
});
exports.FileName = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    fontSize: "14px",
    flex: 1,
    color: theme.colours.slate
}));
exports.DeleteIcon = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    marginRight: "6px",
    color: theme.colours.slate
}));
//# sourceMappingURL=data:application/json;base64,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